import {ISyncField} from "../../../index";

interface ISelectSyncField {
    syncfield: ISyncField
    selected: KnockoutObservable<boolean>,
}
